import React from "react";


function Logo() {
    return (<div></div>)
}

export default Logo;